import { render, staticRenderFns } from "./DashboardArtist.vue?vue&type=template&id=4118705a&"
import script from "./DashboardArtist.vue?vue&type=script&lang=js&"
export * from "./DashboardArtist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports